<template>
  <div class="home-mobile relative px-[12px] pt-14 flex flex-col min-h-full bg-[#F7F8FC] scrollbar-hide"
    @pointerdown.capture="resumeHomePopups"
    :class="{ 'pt-3': isMiniapp }"
    :style="homeMobileStyle">

    <!-- <div class="home-mobile bg-[#F9F6F6] px-[20px] sticky top-0 z-10 flex justify-between items-center" 
          :style="{ 
              paddingTop: barHeight + 'px', /* 状态栏安全距离 */
              zIndex: 999 
          }"
      >
    
      </div> -->
      <div class="flex h-[38px] w-full items-center justify-between ">
        <img :src="mobileTitle" alt="一点PPT" class="w-[80px] object-cover" />
        <div class="flex items-center gap-[8px]">
          <button type="button" class="relative h-[34px] w-[34px] border-none bg-transparent p-0" @click="goNotification">
            <img :src="noticeEntryIcon" alt="消息" class="w-[34px] h-[34px]" />
            <span v-if="notificationToken && hasUnread" class="absolute right-[2px] top-[2px] h-[6px] w-[6px] rounded-full border border-white bg-[#FF4D4D]"></span>
          </button>
        </div>
      </div>

      <div class="flex items-center justify-between mt-2">
        <el-image class="h-[56px] w-[192px] pl-[3px]" :src="Title" alt="一点ppt-标题" />
        <img :src="home_right_icon" alt="" class="h-[82px] max-w-[132px] cursor-pointer">
      </div>

    <div class="mobile-input-mode-tabs">
      <button
        v-for="tab in inputTabs"
        :key="tab.key"
        type="button"
        class="mobile-input-mode-tab"
        :class="{ 'is-active': activeInputTab === tab.key }"
        @click="switchInputTab(tab.key)"
      >
        <img :src="tab.icon" :alt="tab.label" class="mobile-input-mode-icon" />
        <span>{{ tab.label }}</span>
      </button>
    </div>

    <div class="yidian-home-content mt-0 bg-[#ffffff] px-[12px] py-[16px] rounded-[16px]">
      <!-- 主输入框 -->
      <div class="main-input-wrapper">
        <!-- 渐变边框容器 -->
        <div class="gradient-border">
          <div v-if="activeInputTab === 'theme'" class="input-content">
            <div v-if="attachments.length" ref="attachmentsRef" class="mobile-attachment-list">
              <div v-for="item in attachments" :key="item.id" class="mobile-attachment-card">
                <img :src="item.isImage ? item.preview : getFileIcon(item.file.name)" alt="" class="mobile-attachment-icon" />
                <div class="mobile-attachment-info">
                  <p class="mobile-attachment-name">{{ item.file.name }}</p>
                  <p class="mobile-attachment-status" :class="{ 'is-error': item.status === 'error' }">
                    {{ item.status === 'ready' ? '已上传' : item.status === 'error' ? '上传失败' : item.status === 'waiting' ? '等待上传' : '上传中...' }}
                    <span v-if="item.status === 'uploading'"> {{ item.progress }}%</span>
                    · {{ formatAttachmentSize(item.file.size) }}
                  </p>
                  <div v-if="item.status === 'uploading'" class="mobile-attachment-progress" role="progressbar" :aria-valuenow="item.progress" aria-valuemin="0" aria-valuemax="100" :aria-label="item.file.name">
                    <span :style="{ width: `${item.progress}%` }"></span>
                  </div>
                </div>
                <button type="button" class="mobile-attachment-remove" :aria-label="`删除${item.file.name}`" @click="removeAttachment(item.id)"><Close class="mobile-attachment-remove-icon" /></button>
              </div>
            </div>

            <!-- 主输入框 -->
            <div class="mobile-text-input-area">
              <textarea
                v-model="outlineParams.inputText"
                placeholder=""
                class="main-input scrollbar-style"
                :rows="2"
                :maxlength="INPUT_TEXT_MAX_LEN"
                @focus="handleInputFocus"
                @blur="handleInputBlur"
              ></textarea>
              <div v-if="showShinyPlaceholder" class="shiny-placeholder">
                请输入PPT主题，如：新能源汽车发展
              </div>
            </div>


            <!-- 修改：将原来的 input-actions 替换为动态内容，保持位置不变 -->
            <div class="input-actions">
              <button class="upload-btn hover:opacity-80 font-medium" :disabled="isUploading" @click="openFileSelector">
                <img :src="upload" alt="一点ppt-上传文档按钮" class="w-[16px] h-[16px]" />
                <span class="pt-[1px]">{{ isUploading ? '上传中...' : attachments.length ? '继续上传' : '导入文档' }}</span>
              </button>
              <div v-if="isInputFocused" class="input-char-count">
                {{ inputTextLength }}/{{ INPUT_TEXT_MAX_LEN }}
              </div>
            </div>
          </div>
          <div v-else class="upload-content">
            <button type="button" class="mobile-upload-panel" :disabled="isUploading || localFileInfo?.status === 'uploading'" @click="openFileSelector">
              <template v-if="activeInputTab === 'beautify'">
                <img :src="pptIcon" alt="PPT" class="mobile-upload-main-icon" />
                <span class="mobile-upload-title">点击上传PPT</span>
                <span class="mobile-upload-desc">支持上传.pptx文件，文件大小不超过150MB</span>
              </template>
              <template v-else>
                <span class="mobile-upload-file-icons">
                  <img :src="wordIcon" alt="Word" />
                  <img :src="pdfIcon" alt="PDF" />
                  <img :src="txtIcon" alt="TXT" />
                </span>
                <span class="mobile-upload-title">点击上传一键生成专业PPT</span>
                <span class="mobile-upload-desc">最多5个文档、5张图片，单个文件不超过20MB</span>
              </template>
            </button>
          </div>
        </div>
      </div>

      <div v-if="activeInputTab === 'theme'" class="mobile-input-options-row flex items-center">
        <div class="mobile-input-options-scroll-wrap min-w-0 flex-1">
          <div ref="inputOptionsScrollRef" class="mobile-input-options-scroll scrollbar-hide">
            <div class="input-options-inner">
          <div class="option-item option-select-trigger" @click="openOptionDrawer('page')">
            <span class="option-label">
              <span class="option-label-name">{{ pageLabelParts.name }}</span>
              <span v-if="pageLabelParts.value" class="option-label-value">{{ pageLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <!-- <div class="option-item option-select-trigger" @click="openOptionDrawer('language')">
            <span class="option-label">
              <span class="option-label-name">{{ languageLabelParts.name }}</span>
              <span v-if="languageLabelParts.value" class="option-label-value">{{ languageLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div> -->
          <div class="option-item option-select-trigger" @click="openOptionDrawer('textVolume')">
            <span class="option-label">
              <span class="option-label-name">{{ textVolumeLabelParts.name }}</span>
              <span v-if="textVolumeLabelParts.value" class="option-label-value">{{ textVolumeLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="option-item option-select-trigger" @click="openOptionDrawer('audiences')">
            <span class="option-label">
              <span class="option-label-name">{{ audiencesLabelParts.name }}</span>
              <span v-if="audiencesLabelParts.value" class="option-label-value">{{ audiencesLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="option-item option-select-trigger" @click="openOptionDrawer('scene')">
            <span class="option-label">
              <span class="option-label-name">{{ sceneLabelParts.name }}</span>
              <span v-if="sceneLabelParts.value" class="option-label-value">{{ sceneLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
            </div>
          </div>
        </div>
        <button type="button" class="option-edit-btn" @click="openOptionDrawer('page')">
          <img :src="customize" alt="" class="w-[20px] h-[20px]">
        </button>
      </div>

      <!-- 选项设置抽屉 -->
      <el-drawer 
        v-model="optionDrawerVisible"
        :with-header="false"
        modal-class="mobile-option-drawer"
        body-class="!p-0"
        :size="optionDrawerSize"
        direction="btt"
        @closed="handleOptionDrawerClosed"
      >
        <div class="option-drawer-panel">
          <div class="option-drawer-tabs">
            <button
              v-for="tab in optionTabs"
              :key="tab.key"
              type="button"
              class="option-drawer-tab"
              :class="{ 'is-active': optionDrawerType === tab.key }"
              @click="switchOptionTab(tab.key)"
            >
              <img
                :src="optionDrawerType === tab.key ? tab.activeIcon : tab.icon"
                alt=""
                class="option-drawer-tab-icon"
              />
              <span>{{ tab.label }}</span>
            </button>
          </div>

          <div class="option-drawer-content scrollbar-style scrollbar-hide">
            <div v-if="optionDrawerType === 'scene'" class="option-grid">
              <button
                v-for="item in sceneOpts"
                :key="item.value"
                type="button"
                class="option-grid-item"
                :class="{ 'is-selected': isDraftOptionSelected(item.value) }"
                @click="selectDraftOption(item.value)"
              >
                {{ item.label }}
              </button>
              <button
                type="button"
                class="option-grid-item option-grid-item--custom"
                :class="{ 'is-selected': isDraftCustomSceneSelected }"
                @click="openCustomSceneModal"
              >
                <img
                  :src="isDraftCustomSceneSelected ? customize_sel : customize"
                  alt=""
                  class="option-grid-custom-icon"
                />
                <span class="truncate">{{ customSceneButtonText }}</span>
              </button>
            </div>
            <div v-else class="option-grid">
              <button
                v-for="item in currentDrawerOptions"
                :key="item.value"
                type="button"
                class="option-grid-item"
                :class="{ 'is-selected': isDraftOptionSelected(item.value) }"
                @click="selectDraftOption(item.value)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>

          <div class="option-drawer-footer">
            <button type="button" class="option-drawer-btn option-drawer-btn--ghost" @click="resetOptionDrawer">
              恢复默认
            </button>
            <button type="button" class="option-drawer-btn option-drawer-btn--primary" @click="confirmOptionDrawer">
              确认设置
            </button>
          </div>
        </div>
      </el-drawer>
      <!-- :class="canSubmit ? 'btn-enabled' : 'btn-disabled'" -->
      <div
        v-if="activeInputTab === 'theme'"
        class="yidian-mobile-btn btn-enabled flex items-center justify-center w-full mx-auto py-[11px] mt-[16px] text-[#ffffff] text-[15px] rounded-[110px] cursor-pointer"
       @click="handleCreate">
        <el-image class="w-[22px] h-[22px] mr-2" :src="xin" alt="一点ppt-标题" />
        立即生成
      </div>
      <!-- 微信小程序审核：AI 生成内容标识 -->
      <div v-if="isMiniapp" class="miniapp-ai-disclaimer">
        内容由 AI 生成，仅供参考
      </div>
  
      <!-- 热点模块：两行各自横向滚动 + 默认走马灯 -->
      <div ref="hotTopicsContainerRef" class="mobile-hot-topics mt-[12px]" v-if="activeInputTab === 'theme'">
        <div
          v-for="(row, rowIndex) in hotModelRows"
          :key="rowIndex"
          :ref="(el) => setHotRowRef(el, rowIndex)"
          class="mobile-hot-topics-row scrollbar-hide"
          @touchstart.passive="pauseHotMarquee(rowIndex)"
          @touchend="resumeHotMarquee()"
          @touchcancel="resumeHotMarquee()"
          @mousedown="pauseHotMarquee(rowIndex)"
          @mouseup="resumeHotMarquee()"
          @mouseleave="resumeHotMarquee()"
          @scroll="handleHotRowScroll"
        >
          <div
            class="hot-topics-inner"
            :class="{
              'is-marquee-paused': hotMarqueeUserInteracting,
              'is-marquee-manual': hotMarqueeManualMode,
            }"
            :style="{ animationDuration: rowIndex === 0 ? '26s' : '32s' }"
          >
            <template v-for="copy in 2" :key="`copy-${rowIndex}-${copy}`">
              <div
                v-for="item in row"
                :key="`${copy}-${item.id}`"
                class="hot-topic-item"
                @click="changeHot(item)"
              >
                <el-image class="w-[14px] h-[14px] flex-shrink-0" :src="hot" alt="" />
                <span class="truncate text-brands/[0.6]">{{ item.name }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>

    </div>


    <div ref="memberBannerRef" class="member-banner mt-[10px]" v-if="activityBannerList.length > 0">
      <swiper
        :modules="bannerModules"
        :slides-per-view="1"
        :loop="activityBannerList.length > 1"
        :space-between="10"
        :autoplay="{ delay: 5000, disableOnInteraction: false }"
        class="swiper-member"
      >
        <swiper-slide v-for="(item, index) in activityBannerList" :key="item.id ?? index">
          <el-image class="member-banner-image" :src="item.content" fit="cover" @click="goAndiroMember(item)" />
        </swiper-slide>
      </swiper>
    </div>

    <section class="mobile-hot-apps mt-[10px]">
      <div class="mobile-hot-apps-header">
        <div class="mobile-hot-apps-title" @click="handleMobileApplicationMore">
          <img :src="airemMobile" alt="" />
          <h2>热门专题</h2>
        </div>
        <button type="button" class="mobile-hot-apps-more" @click="handleMobileApplicationMore">
          <span>查看更多</span>
          <img :src="chevronIcon" alt="" />
        </button>
      </div>

      <div class="mobile-hot-apps-grid">
        <template v-if="mobileHotApplicationsLoading">
          <div
            v-for="item in 4"
            :key="`mobile-hot-app-skeleton-${item}`"
            class="mobile-hot-app-card mobile-hot-app-card--skeleton"
          >
            <el-skeleton animated>
              <template #template>
                <div class="mobile-hot-app-skeleton-content">
                  <div>
                    <el-skeleton-item variant="text" class="mobile-hot-app-skeleton-title" />
                    <el-skeleton-item variant="text" class="mobile-hot-app-skeleton-desc" />
                  </div>
                  <el-skeleton-item variant="image" class="mobile-hot-app-skeleton-icon" />
                </div>
              </template>
            </el-skeleton>
          </div>
        </template>
        <button
          v-else
          v-for="app in mobileHotApplications"
          :key="app.id"
          type="button"
          class="mobile-hot-app-card"
          @click="handleMobileApplicationClick(app)"
        >
          <img :src="airemMobileBg" alt="" class="mobile-hot-app-bg" />
          <span class="mobile-hot-app-text">
            <strong>{{ app.title }}</strong>
            <span>{{ app.description || '' }}</span>
          </span>
          <img :src="app.icon" :alt="app.title" class="mobile-hot-app-icon" />
          <span
            v-if="app.badge != 'none'"
            class="mobile-hot-app-badge"
            :class="app.badge === 'hot' ? 'mobile-hot-app-badge-hot' : 'mobile-hot-app-badge-new'"
          >{{ app.badge == 'hot' ? 'Hot' : 'New' }}</span>
        </button>
        <div v-if="!mobileHotApplicationsLoading && !mobileHotApplications.length" class="mobile-hot-apps-empty">
          暂无热门专题
        </div>
      </div>
    </section>

    <section class="mt-[10px] bg-[#ffffff] px-[12px] py-[16px] rounded-[16px] flex  flex-col">
        <div class="shrink-0 flex items-center justify-between">
          <div class="flex items-center gap-[4px]">
            <img :src="sectionTitleIcon" alt="" class="h-[16px] w-[16px] ml-[6px]"  />
            <h2 class="text-[15px] font-semibold leading-[24px] text-[#1d1f26]">模板风格预览</h2>
          </div>

          <button
            type="button"
            class="flex items-center gap-[4px] border-none bg-transparent p-0 text-[14px] leading-[16px] "
            @click="handleAllTemplates"
          >
            <span class="whitespace-nowrap font-medium text-[14px] text-brands/[0.5]">全部模板</span>
            <img :src="chevronIcon" alt="" class="h-[12px] w-[12px]" />
          </button>
        </div>

        <div
          ref="templateScrollContainerRef"
          class="mt-[10px] min-h-0 flex-1 overflow-y-auto  pr-[2px] scrollbar-hide"
          @scroll="handleTemplateScroll"
        >
          <div v-if="templatesLoading" class="grid grid-cols-2 gap-x-[12px] gap-y-[8px]">
            <div
              v-for="item in 8"
              :key="item"
              class="text-left"
            >
              <div class="aspect-video overflow-hidden rounded-[7.2px] border border-[rgba(2,10,57,0.13)] bg-[#f6f7f8]" />
              <div class="mt-[8px] h-[12px] w-[72px] rounded-full bg-[#eff1f5]" />
            </div>
          </div>

          <template v-else-if="templates.length">
            <div class="grid grid-cols-2 gap-x-[12px] gap-y-[12px]">
              <button
                v-for="template in templates.slice(0, 4)"
                :key="template.id"
                type="button"
                class="template-card-button block w-full text-left"
                @click="handleTemplateClick(template)"
              >
                <div class="relative aspect-video overflow-hidden rounded-[8px] border border-solid border-[rgba(2,10,57,0.13)] bg-white" style="--ppt-thumbnail-radius: 6.2px">
                  <img
                    v-if="shouldShowTemplateHomepage(template)"
                    :src="template.homepage"
                    :alt="template.title"
                    class="h-full w-full object-cover"
                    @error="handleTemplateHomepageError(template)"
                  />
                  <div
                    v-else
                    class="relative flex h-full w-full items-center justify-center bg-[#f6f7f8]"
                  >
                    <img :src="placeholderBg" alt="" class="h-full w-full object-cover" />
                    <img :src="placeholderAnim" alt="加载中" class="absolute h-[28px] w-[28px]" />
                  </div>
                  <div v-if="isVipTemplate(template)" class="absolute right-[6px] top-[6px] z-30 flex h-[22px] w-[82px] items-center rounded-[42px] bg-[linear-gradient(180deg,#3E2F1C_0%,#25221D_100%)] pl-[9px] pr-[8px]">
                    <img :src="vipIcon" alt="" class="h-[14px] w-[14px] shrink-0" />
                    <span class="ml-[4px] whitespace-nowrap text-center text-[12px] font-normal leading-[21px] text-[#FFE279]">会员专享</span>
                  </div>
                </div>
                <p class="mt-[8px] truncate text-[12px] leading-[12px] text-[rgba(1,3,10,0.89)]">{{ template.title }}</p>
              </button>
            </div>
          </template>

          <div v-else class="flex h-full min-h-[180px] items-center justify-center text-[12px] leading-[18px] text-[rgba(6,10,38,0.48)]">
            暂无相关模板
          </div>
        </div>
      </section>


    <!-- 自定义场景弹窗 -->
    <div v-if="customSceneModalVisible" class="custom-scene-overlay" @click.self="closeCustomSceneModal">
      <div class="custom-scene-modal" @click.stop>
        <h3 class="custom-scene-title">自定义场景</h3>
        <div class="custom-scene-input-wrap">
          <input
            v-model="customSceneInput"
            type="text"
            maxlength="15"
            class="custom-scene-input"
            placeholder="请输入自定义场景"
            @keyup.enter="confirmCustomScene"
          />
          <span class="custom-scene-count">{{ customSceneInput.length }}/15</span>
        </div>
        <div class="custom-scene-actions">
          <button type="button" class="custom-scene-btn custom-scene-btn--ghost" @click="closeCustomSceneModal">
            取消
          </button>
          <button type="button" class="custom-scene-btn custom-scene-btn--primary" @click="confirmCustomScene">
            确定
          </button>
        </div>
      </div>
    </div>

    <!-- 隐藏的文件输入 -->
    <input type="file" ref="fileInput" style="display: none" @change="onFileChange" :accept="acceptFileTypes" :multiple="!isBeautifyMode" />
  </div>
  <CouponReceivedMobile v-if="!isIOS" ref="CouponReceivedMobileRef" :auto-show="false" :modal-mode="true" />
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onBeforeUnmount, onActivated, onDeactivated, watch } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'
import { useFileStore } from '@/store/file'
import { useSlidesStore } from '@/store'
import * as TemplateApi from '@/api/template.ts'
import { getDataByType, isVipTemplate } from '@/utils/common'
import { showAndiroTab, getIOSInfo, reportEvent, isGrantedPermission, requestPermission, syncTabBarHeightIfNeeded, isMiniAppWebview, ensureNativeLogin, requestMiniAppSwitchTab, requestMiniAppOpenWebview, getToken } from '@/utils/auth.ts'
import { persistOutlineDraftIfPossible, saveOutlineDraftToStorage, encodeOutlineDraftForTransport, writeOutlineDraftToCookie, OUTLINE_DRAFT_STORAGE_KEY } from '@/utils/createDraftCache'
import { isPointInElement, toGesturePoint, registerCustomGestureHandler, unregisterCustomGestureHandler } from '@/utils/customGesture'
import { useCreateDraftCache } from '@/hooks/useCreateDraftCache'
import useImport from '@/hooks/useImport'
import { parseDocument } from '@/api/documents'
import { MAX_UPLOAD_SIZE, showUploadSizeError } from '@/utils/uploadLimit'
import { buildEnhancePptParams } from '@/utils/enhancePpt'
import { ElMessage } from 'element-plus'
import { ArrowDown, Close, EditPen, Loading } from '@element-plus/icons-vue'
import upload from '@/assets/images/home/input_upload.png';
import entTheme from '@/assets/images/home/ent_theme.png'
import pptBeautify from '@/assets/images/home/ppt_beautify.png'
import importFile from '@/assets/images/home/import_file.png'
import pptIcons from '@/assets/images/home/file_ppt.png'
import hot from '@/assets/images/mobile/hot.png'
import xin from '@/assets/images/home/xin2.png'
import Title from '@/assets/images/mobile/home_title.png'
import home_right_icon from '@/assets/images/mobile/home_right_icon.png'
import noticeEntryIcon from '@/assets/images/home/mobile-header-notice-entry.png'
import word from '@/assets/images/PPT/file_word.png'
import text from '@/assets/images/PPT/file_text.png'
import pdf from '@/assets/images/PPT/file_pdf.png'
import sectionTitleIcon from '@/assets/images/pptHome/icons/section-title.png'
import chevronIcon from '@/assets/images/pptHome/icons/chevron.png'
import placeholderBg from '@/assets/images/home/bg_loading.png'
import placeholderAnim from '@/assets/images/home/loading_star.webp'
import airemMobile from '@/assets/images/mobile/airem_mobile.png'
import airemMobileBg from '@/assets/images/mobile/airem_mobilebg.png'
import vipIcon from '@/assets/images/member/icon_vip.png'
import { languageOptions } from '@/utils/language'
import { textOpts, audiencesOpts, sceneOpts } from '@/utils/pptInputOptions'
import customize from '@/assets/images/home/customize.png'
import customize_sel from '@/assets/images/home/customize_sel.png'
import page from '@/assets/images/pptHome/icons/page.svg'
import page_active from '@/assets/images/pptHome/icons/page_active.svg'
import language from '@/assets/images/pptHome/icons/language.svg'
import language_active from '@/assets/images/pptHome/icons/language_active.svg'
import audiences from '@/assets/images/pptHome/icons/audiences.svg'
import audiences_active from '@/assets/images/pptHome/icons/audiences_active.svg'
import scene from '@/assets/images/pptHome/icons/scene.svg'
import scene_active from '@/assets/images/pptHome/icons/scene_active.svg'
import textVolume from '@/assets/images/pptHome/icons/textVolume.svg'
import textVolume_active from '@/assets/images/pptHome/icons/textVolume_active.svg'
import mobileTitle from '@/assets/images/mobile/mobile_title.png'
import * as UserApi from '@/api/user.ts'
import { getUnreadCount } from '@/api/notification.ts'
import { ACTIVITY_LOCATION } from '@/utils/activityLocation'
import { LOGIN_SUCCESS_EVENT } from '@/utils/loginEvents'
import { canOpenHomePopup, resumeHomePopups, suspendHomePopups } from '@/utils/homePopupGuard'
import CouponReceivedMobile from '@/views/yidian/Home/CouponReceivedMobile.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import * as HomeApi from '@/api/home.ts'
import {
  getBotHomeListFromResponse,
  isBotHomeSuccess,
  normalizeApplicationList,
} from '@/views/yidian/Applications/applicationData'

const router = useRouter()
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent || '')
const CouponReceivedMobileRef = ref(null)
let homeCouponModalLastRequestedAt = 0

const openHomeCouponModal = async () => {
  if (isIOS) return
  if (router.currentRoute.value.path !== '/m/home') return
  if (!canOpenHomePopup()) return
  const now = Date.now()
  if (now - homeCouponModalLastRequestedAt < 1000) return
  homeCouponModalLastRequestedAt = now
  await nextTick()
  if (!canOpenHomePopup()) return
  CouponReceivedMobileRef.value?.open?.({ preferNative: true, shouldOpen: canOpenHomePopup })
}

const handleLoginSuccess = () => {
  openHomeCouponModal()
}

const appStore = useAppStore()
const userStore = useUserStore()
const fileStore = useFileStore()
const slidesStore = useSlidesStore()
const { outlineParams, tabBarHeight } = storeToRefs(appStore)
const isMiniapp = isMiniAppWebview()
const { uploadedFile } = storeToRefs(fileStore)
const { importPPTXFile } = useImport()

const andrioInfo = computed(() => appStore.getAndrio)
const isHarmonyYdppt = computed(() => /harmony_ydppt/i.test(navigator.userAgent || ''))
const homeMobileStyle = computed(() => ({
  paddingBottom: andrioInfo.value.platform === 'IOS' ? `${tabBarHeight.value + 15}px` : isHarmonyYdppt.value ? '95px' : '25px',
}))

// 未读消息红点
const notificationToken = ref(getToken())
const hasUnread = ref(false)
const unreadCount = ref(0)
const NOTIFICATION_UNREAD_REFRESH_EVENT = 'notification-unread-refresh'

const syncNotificationToken = () => {
  notificationToken.value = getToken()
  if (!notificationToken.value) {
    hasUnread.value = false
    unreadCount.value = 0
  }
  return notificationToken.value
}

const fetchUnreadCount = async () => {
  if (!syncNotificationToken()) return
  try {
    const res = await getUnreadCount({ params: {} })
    if (res.code === 'SUCCESS') {
      unreadCount.value = Number(res.data) || 0
      hasUnread.value = unreadCount.value > 0
    }
  } catch {}
}

const goNotification = () => {
  reportEvent('msg_bell_click', {
    unread_count: unreadCount.value
  })
  if (!ensureNativeLogin('/m/notification')) return
  window.location.href = 'ydppt://webview?url=' + location.origin + '/m/notification' + '&title='
  // router.push('/m/notification')
}

const bannerModules = [Autoplay]
const mobileHotApplications = ref([])
const mobileHotApplicationsLoading = ref(false)

const activityBannerList = ref([])

const getHomeBannerList = async () => {
  try {
    const res = await UserApi.getBannerListByLocation({
      params: {
        location: ACTIVITY_LOCATION.HOME
      }
    })
    if (res.code === 'SUCCESS') {
      activityBannerList.value = Array.isArray(res.data) ? res.data : []
    }
  } catch {
    activityBannerList.value = []
  }
}

// bannerList: [
//   {
//       content: activePositive,
//       id: 1,
//       linkUrl: 'https://alidocs.dingtalk.com/notable/share/form/v01eYVOL5oz0p5Pzlpz_H9EkGJ0_yvVzwb0?source=link',
//       title: '好评送会员',
//     },
//     {
//       content: activeBanner,
//       id: 2,
//       linkUrl: 'activities-sdk',
//       title: '扫码进福利群',
//     },
//     {
//       content: activeBanner,
//       id: 3,
//       linkUrl: '/m/invite',
//       title: '邀请好友赢好礼',
//     },
//     {
//       content: activePositive,
//       id: 4,
//       linkUrl: '/m/my-coupon',
//       title: '领劵中心',
//     },
//   ],
// const languageOptions = [
//   { value: 'zh', label: '语言：中文' },
//   { value: 'en', label: '语言：英文' },
// ]

// 文件上传相关（按需加载，避免阻塞首屏）
const fileInput = ref(null)
let uploadRuntime = null
// 本地文件信息用于 UI 展示
const localFileInfo = ref(null)
const attachments = ref([])
const attachmentsRef = ref(null)
const isUploading = ref(false)
const imageExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif']
const documentExtensions = ['.doc', '.docx', '.txt', '.pdf', '.md', '.markdown', '.xls', '.xlsx']
const uploadTimers = new Map()
let attachmentId = 0
let uploadSession = 0
const pics = computed(() => attachments.value.filter(item => item.isImage && item.status === 'ready').map(item => item.url))
const documentContent = computed(() => attachments.value
  .filter(item => !item.isImage && item.status === 'ready')
  .map(item => item.content)
  .filter(content => content.trim().length > 0)
  .join(';'))

const INPUT_TAB_KEYS = {
  THEME: 'theme',
  BEAUTIFY: 'beautify',
  IMPORT: 'import'
}

const activeInputTab = ref(INPUT_TAB_KEYS.THEME)
const inputTabs = [
  { key: INPUT_TAB_KEYS.THEME, label: '输入主题', icon: entTheme },
  { key: INPUT_TAB_KEYS.BEAUTIFY, label: 'PPT美化', icon: pptBeautify },
  { key: INPUT_TAB_KEYS.IMPORT, label: '导入文件', icon: importFile },
]

const pptIcon = pptIcons
const wordIcon = word
const pdfIcon = pdf
const txtIcon = text

const acceptFileTypes = computed(() => {
  // 小程序 WebView 会把混合扩展名过滤器解析成只能选图片，这里放开类型限制。
  // Keep format validation in uploadSelectedFiles / handleBeautifyPptFile.
  if (isMiniapp) return '*/*'
  return activeInputTab.value === INPUT_TAB_KEYS.BEAUTIFY ? '.pptx' : [...documentExtensions, ...imageExtensions].join(',')
})

const switchInputTab = (tab) => {
  activeInputTab.value = tab
}


const TEMPLATE_PAGE_SIZE = 10
const TEMPLATE_SCROLL_THRESHOLD = 80

const inputOptionsScrollRef = ref(null)
const hotTopicsContainerRef = ref(null)
const memberBannerRef = ref(null)
const hotRowRefs = ref([])
const templateScrollContainerRef = ref(null)
const templates = ref([])
const templatesLoading = ref(false)
const templatesLoadingMore = ref(false)
const templatesPageNo = ref(1)
const templatesTotal = ref(0)
const templatesHasMore = computed(() => templates.value.length < templatesTotal.value)

const normalizeTemplateItem = (item) => ({
  ...item,
  title: item.name,
  homepage: getDataByType(item.coverList, 'homePage'),
  homepageLoadFailed: false
})

const ensureUploadRuntime = async () => {
  if (uploadRuntime) return uploadRuntime
  const { useFileUpload } = await import('@/hooks/useFileUpload')
  uploadRuntime = useFileUpload({
    fileSizeLimit: MAX_UPLOAD_SIZE,
    textLengthLimit: 20000, // 2万字
    allowedTypes: [...documentExtensions, ...imageExtensions]
  })
  return uploadRuntime
}

const isBeautifyMode = computed(() => activeInputTab.value === INPUT_TAB_KEYS.BEAUTIFY)

const INPUT_TEXT_MAX_LEN = 10000
const isInputFocused = ref(false)

const inputTextLength = computed(() => (outlineParams.value.inputText || '').length)

const handleInputFocus = () => {
  isInputFocused.value = true
}

const handleInputBlur = () => {
  isInputFocused.value = false
}

const showShinyPlaceholder = computed(() => {
  return !outlineParams.value.inputText?.trim() && !isInputFocused.value
})

// 是否可以提交（有输入内容或已上传文件）
const canSubmit = computed(() => {
  const hasText = outlineParams.value.inputText && outlineParams.value.inputText.trim()
  const hasSuccessFile = attachments.value.some(item => item.status === 'ready') || outlineParams.value.pics?.length || localFileInfo.value?.status === 'success'
  return hasText || hasSuccessFile || outlineParams.value.fujian
})

// 获取文件图标
const getFileIcon = (filename) => {
  const ext = filename.split('.').pop()?.toLowerCase() || ''
  if (ext === 'docx' || ext === 'doc') return word
  if (ext === 'txt') return text
  return pdf
}

// 页数选项
const pageOptions = [
  { value: '5-10页', label: '页数: 5-10页' },
  { value: '10-15页', label: '页数: 10-15页' },
  { value: '15-20页', label: '页数: 15-20页' },
  { value: '20-25页', label: '页数: 20-25页' },
  { value: '25-30页', label: '页数: 25-30页' },
  { value: '30-35页', label: '页数: 30-35页' },
  { value: '35-40页', label: '页数: 35-40页' },
  { value: '40-45页', label: '页数: 40-45页' },
  { value: '20页以内', label: '页数: 智能页数' },
];

const optionDrawerItemsMap = {
  page: pageOptions,
  language: languageOptions,
  audiences: audiencesOpts,
  textVolume: textOpts,
  scene: sceneOpts
}

const optionTabs = [
  { key: 'language', label: '语言', icon: language, activeIcon: language_active },
  { key: 'page', label: '页数', icon: page, activeIcon: page_active },
  { key: 'audiences', label: '受众', icon: audiences, activeIcon: audiences_active },
  { key: 'scene', label: '场景', icon: scene, activeIcon: scene_active },
  { key: 'textVolume', label: '文本', icon: textVolume, activeIcon: textVolume_active }
]

const defaultOutlineOptions = {
  pageCount: '20页以内',
  language: 'zh',
  audiences: '',
  textVolume: '详细',
  scene: ''
}

useCreateDraftCache({
  outlineParams,
  uploadedFile,
  localFileInfo,
  defaultOutlineOptions,
  fileStore,
})

const CUSTOM_SCENE_MAX_LENGTH = 15

// 页数/语言/受众/文本量/场景选择抽屉
const optionDrawerVisible = ref(false)
const optionDrawerType = ref('language')
const customSceneModalVisible = ref(false)
const customSceneInput = ref('')
const draftParams = ref({ ...defaultOutlineOptions })

const optionDrawerSize = computed(() => {
  const isAndroid = andrioInfo.value.platform === 'ANDROID'
  return isAndroid ? '45%' : '48%'
})

const pageDrawerOptions = pageOptions.map((item) => ({
  value: item.value,
  label: item.label.replace('页数: ', '')
}))

const currentDrawerOptions = computed(() => {
  const type = optionDrawerType.value
  if (type === 'page') return pageDrawerOptions
  return optionDrawerItemsMap[type] || []
})

const isDraftCustomSceneSelected = computed(() => {
  const scene = draftParams.value.scene
  return Boolean(scene) && !sceneOpts.some((item) => item.value === scene)
})

const customSceneButtonText = computed(() => {
  if (isDraftCustomSceneSelected.value) {
    return draftParams.value.scene
  }
  return '自定义'
})

const pageLabelParts = computed(() => {
  const item = pageOptions.find((o) => o.value === outlineParams.value.pageCount)
  return {
    name: '页数',
    value: item ? item.label.replace('页数: ', '') : ''
  }
})

const languageLabelParts = computed(() => {
  const item = languageOptions.find((o) => o.value === outlineParams.value.language)
  return {
    name: '语言',
    value: item?.label || ''
  }
})

const audiencesLabelParts = computed(() => ({
  name: '受众',
  value: outlineParams.value.audiences || ''
}))

const textVolumeLabelParts = computed(() => ({
  name: '文本量',
  value: outlineParams.value.textVolume || ''
}))

const sceneLabelParts = computed(() => {
  const scene = outlineParams.value.scene
  if (!scene) return { name: '场景', value: '' }
  const matched = sceneOpts.find((o) => o.value === scene)
  return {
    name: '场景',
    value: matched ? matched.label : scene
  }
})
const syncDraftFromOutline = () => {
  draftParams.value = {
    pageCount: outlineParams.value.pageCount || defaultOutlineOptions.pageCount,
    language: outlineParams.value.language || defaultOutlineOptions.language,
    audiences: outlineParams.value.audiences || defaultOutlineOptions.audiences,
    textVolume: outlineParams.value.textVolume || defaultOutlineOptions.textVolume,
    scene: outlineParams.value.scene || defaultOutlineOptions.scene
  }
}

const isDraftOptionSelected = (value) => {
  const type = optionDrawerType.value
  if (type === 'page') return draftParams.value.pageCount === value
  if (type === 'language') return draftParams.value.language === value
  if (type === 'audiences') return draftParams.value.audiences === value
  if (type === 'textVolume') return draftParams.value.textVolume === value
  return draftParams.value.scene === value
}

const openOptionDrawer = (type) => {
  syncDraftFromOutline()
  optionDrawerType.value = type
  optionDrawerVisible.value = true
  showAndiroTab(false)
}

const switchOptionTab = (type) => {
  optionDrawerType.value = type
}

const closeOptionDrawer = () => {
  optionDrawerVisible.value = false
  showAndiroTab(true)
}

const handleOptionDrawerClosed = () => {
  customSceneModalVisible.value = false
  customSceneInput.value = ''
  showAndiroTab(true)
}

const selectDraftOption = (value) => {
  const type = optionDrawerType.value
  if (type === 'page') {
    draftParams.value.pageCount = value
  } else if (type === 'language') {
    draftParams.value.language = value
  } else if (type === 'audiences') {
    draftParams.value.audiences = value
  } else if (type === 'textVolume') {
    draftParams.value.textVolume = value
  } else if (type === 'scene') {
    draftParams.value.scene = value
  }
}

const applyDraftToOutline = () => {
  outlineParams.value.pageCount = draftParams.value.pageCount
  outlineParams.value.language = draftParams.value.language
  outlineParams.value.audiences = draftParams.value.audiences
  outlineParams.value.textVolume = draftParams.value.textVolume
  outlineParams.value.scene = draftParams.value.scene
}

const confirmOptionDrawer = () => {
  applyDraftToOutline()
  closeOptionDrawer()
}

const resetOptionDrawer = () => {
  draftParams.value = { ...defaultOutlineOptions }
}

const openCustomSceneModal = () => {
  customSceneInput.value = isDraftCustomSceneSelected.value ? draftParams.value.scene : ''
  customSceneModalVisible.value = true
}

const closeCustomSceneModal = () => {
  customSceneModalVisible.value = false
  customSceneInput.value = ''
}

const confirmCustomScene = () => {
  const trimmed = customSceneInput.value.trim()
  if (!trimmed) {
    ElMessage.error({
      message: '请输入自定义场景',
      offset: 60
    })
    return
  }
  draftParams.value.scene = trimmed.slice(0, CUSTOM_SCENE_MAX_LENGTH)
  closeCustomSceneModal()
}

const hotModels = ref([
  { id: 1, name: '汽车市场分析报告' },
  { id: 2, name: '如何提升电商平台转化率计划' },
  { id: 3, name: '市场部年度目标制定与执行' },
  { id: 4, name: '春季北京周边3日游攻略' },
  { id: 5, name: '分析养生服务行业发展趋势' },
  { id: 6, name: '校园文化节活动策划方案与预算执行细则' },
  { id: 7, name: '大学生创新创业项目汇报' },
])

const hotModelRows = computed(() => {
  const list = hotModels.value
  const mid = Math.ceil(list.length / 2)
  return [list.slice(0, mid), list.slice(mid)]
})

const hotMarqueeUserInteracting = ref(false)
const hotMarqueeManualMode = ref(false)
let hotMarqueeResumeTimer = null
let hotRowScrollEndTimer = null
let hotRowScrollAdjusting = false

const HOT_MARQUEE_RESUME_DELAY = 2500

const setHotRowRef = (el, index) => {
  if (el) {
    hotRowRefs.value[index] = el
  }
}

const getHotRowInner = (rowEl) => rowEl?.querySelector('.hot-topics-inner')

const getHotRowHalfWidth = (rowEl) => {
  const inner = getHotRowInner(rowEl)
  if (!inner) return 0
  return inner.scrollWidth / 2
}

/** 暂停走马灯时，把 CSS transform 偏移同步到 scrollLeft，便于手动无限滚动 */
const syncHotMarqueeToScroll = (rowIndex) => {
  const row = hotRowRefs.value[rowIndex]
  const inner = getHotRowInner(row)
  if (!row || !inner) return

  const transform = window.getComputedStyle(inner).transform
  let translateX = 0
  if (transform && transform !== 'none') {
    translateX = new DOMMatrix(transform).m41
  }

  hotMarqueeManualMode.value = true
  row.scrollLeft = Math.max(0, -translateX)
}

const resetHotRowForMarquee = (rowIndex) => {
  const row = hotRowRefs.value[rowIndex]
  if (!row) return

  row.scrollLeft = 0
}

const restartHotMarqueeAnimations = () => {
  hotMarqueeManualMode.value = false
  hotMarqueeUserInteracting.value = false
  hotRowRefs.value.forEach((row) => {
    const inner = getHotRowInner(row)
    if (inner) {
      void inner.offsetWidth
    }
  })
}

const scheduleHotMarqueeResume = (delay = HOT_MARQUEE_RESUME_DELAY) => {
  if (hotMarqueeResumeTimer) clearTimeout(hotMarqueeResumeTimer)
  hotMarqueeResumeTimer = setTimeout(() => {
    hotRowRefs.value.forEach((_, index) => {
      resetHotRowForMarquee(index)
    })
    restartHotMarqueeAnimations()
    hotMarqueeResumeTimer = null
  }, delay)
}

const handleHotRowScroll = (event) => {
  if (hotRowScrollAdjusting || !hotMarqueeUserInteracting.value) return

  const row = event.target
  const halfWidth = getHotRowHalfWidth(row)
  if (halfWidth <= 0) return

  if (row.scrollLeft >= halfWidth) {
    hotRowScrollAdjusting = true
    while (row.scrollLeft >= halfWidth) {
      row.scrollLeft -= halfWidth
    }
    hotRowScrollAdjusting = false
  }

  if (hotRowScrollEndTimer) clearTimeout(hotRowScrollEndTimer)
  hotRowScrollEndTimer = setTimeout(() => {
    hotRowScrollEndTimer = null
    scheduleHotMarqueeResume()
  }, 180)
}

const pauseHotMarquee = (rowIndex) => {
  if (!hotMarqueeUserInteracting.value) {
    hotRowRefs.value.forEach((_, index) => {
      syncHotMarqueeToScroll(index)
    })
  }
  hotMarqueeUserInteracting.value = true
  if (hotMarqueeResumeTimer) {
    clearTimeout(hotMarqueeResumeTimer)
    hotMarqueeResumeTimer = null
  }
  if (hotRowScrollEndTimer) {
    clearTimeout(hotRowScrollEndTimer)
    hotRowScrollEndTimer = null
  }
}

const resumeHotMarquee = (delay = HOT_MARQUEE_RESUME_DELAY) => {
  scheduleHotMarqueeResume(delay)
}

const clearHotMarqueeTimer = () => {
  if (hotMarqueeResumeTimer) {
    clearTimeout(hotMarqueeResumeTimer)
    hotMarqueeResumeTimer = null
  }
  if (hotRowScrollEndTimer) {
    clearTimeout(hotRowScrollEndTimer)
    hotRowScrollEndTimer = null
  }
}

const init = () => {
  outlineParams.value.pageCount = outlineParams.value.pageCount || defaultOutlineOptions.pageCount
  outlineParams.value.language = outlineParams.value.language || defaultOutlineOptions.language
  outlineParams.value.audiences = outlineParams.value.audiences || defaultOutlineOptions.audiences
  outlineParams.value.textVolume = outlineParams.value.textVolume || defaultOutlineOptions.textVolume
  outlineParams.value.scene = outlineParams.value.scene || defaultOutlineOptions.scene

  if(window.prompt){
    const data = getIOSInfo();
    appStore.setAndrioInfo(data);
  }
  getHomeBannerList()
  setTimeout(() => {
    window.openSdkModal?.(ACTIVITY_LOCATION.HOME)
  }, /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 800 : 300)
}

const handleCustomGesture = (downX, downY) => {
  if (router.currentRoute.value.path !== '/m/home') {
    return false
  }
  const { x, y } = toGesturePoint(downX, downY)
  return (
    isPointInElement(x, y, inputOptionsScrollRef.value) ||
    isPointInElement(x, y, attachmentsRef.value) ||
    isPointInElement(x, y, hotTopicsContainerRef.value) ||
    isPointInElement(x, y, memberBannerRef.value)
  )
}

const setupCustomGesture = () => registerCustomGestureHandler(handleCustomGesture)
const teardownCustomGesture = () => unregisterCustomGestureHandler(handleCustomGesture)

const changeHot = (item) => {
  if (isUploading.value) return
  reportEvent('app_clicks', {
    ck_module: '首页_快捷按钮',
  })
  outlineParams.value.inputText = item.name
  handleCreate()
}

// 文件上传相关方法
const openFileSelector = () => {
  if (isUploading.value || localFileInfo.value?.status === 'uploading') return
  reportEvent('app_clicks', {
    ck_module: '首页_上传文档',
  })
  if (!ensureNativeLogin()) return
  if (fileInput.value) {
    fileInput.value.click()
  }
}

const formatAttachmentSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

const stopUploadProgress = (id) => {
  const timer = uploadTimers.get(id)
  if (timer !== undefined) window.clearInterval(timer)
  uploadTimers.delete(id)
}

const removeAttachment = (id) => {
  const item = attachments.value.find(item => item.id === id)
  if (!item) return
  stopUploadProgress(id)
  if (item.preview) URL.revokeObjectURL(item.preview)
  attachments.value = attachments.value.filter(item => item.id !== id)
  outlineParams.value.fujian = documentContent.value
  outlineParams.value.pics = [...pics.value]
}

// 释放页面上传资源，保留已传给大纲页的输入和图片参数。
const disposeAttachments = () => {
  uploadSession += 1
  attachments.value.forEach(item => {
    stopUploadProgress(item.id)
    if (item.preview) URL.revokeObjectURL(item.preview)
  })
  attachments.value = []
  isUploading.value = false
}

const onFileChange = async (event) => {
  const files = Array.from(event.target.files ?? [])
  event.target.value = ''
  if (!files.length || isUploading.value) return
  if (isBeautifyMode.value) {
    if (files.length !== 1) {
      ElMessage.warning({ message: 'PPT美化请选择一个 .pptx 文件', offset: 60 })
      return
    }
    await handleBeautifyPptFile(files[0])
    return
  }
  await uploadSelectedFiles(files)
}

const uploadSelectedFiles = async (files) => {
  let imageCount = attachments.value.filter(item => item.isImage).length
  let documentCount = attachments.value.length - imageCount
  const pending = []
  for (const file of files) {
    const ext = `.${checkFileType(file.name)}`
    if (![...documentExtensions, ...imageExtensions].includes(ext)) {
      ElMessage.warning({ message: `不支持的文件类型：${file.name}`, offset: 60 })
      continue
    }
    if (file.size > MAX_UPLOAD_SIZE) {
      showUploadSizeError(file.name)
      continue
    }
    const isImage = imageExtensions.includes(ext)
    if ((isImage ? imageCount : documentCount) >= 5) {
      ElMessage.warning({ message: isImage ? '最多上传5张图片' : '最多上传5个文档', offset: 60 })
      continue
    }
    if (isImage) imageCount += 1
    else documentCount += 1
    pending.push({ id: ++attachmentId, file, isImage, preview: isImage ? URL.createObjectURL(file) : '', url: '', content: '', progress: 0, status: 'waiting' })
  }
  if (!pending.length) return
  fileStore.clearFile()
  localFileInfo.value = null
  attachments.value.push(...pending)
  switchInputTab(INPUT_TAB_KEYS.THEME)
  isUploading.value = true
  outlineParams.value.fujian = documentContent.value
  const session = uploadSession
  try {
    for (const pendingItem of pending) {
      if (session !== uploadSession) break
      const item = attachments.value.find(item => item.id === pendingItem.id)
      if (!item) continue
      item.status = 'uploading'
      const startedAt = Date.now()
      const duration = 3000 + item.file.size / (1024 * 1024) * 1200
      uploadTimers.set(item.id, window.setInterval(() => {
        item.progress = Math.min(95, Math.floor(95 * (1 - Math.exp(-(Date.now() - startedAt) / duration))))
      }, 200))
      try {
        if (item.isImage) {
          const runtime = await ensureUploadRuntime()
          item.url = await runtime.uploadFileAndGetUrl(item.file)
        } else {
          const document = await parseDocument(item.file)
          item.content = [document.text, ...(document.csvSheets ?? []).map(sheet => sheet?.csv)]
            .filter(content => typeof content === 'string' && content.trim().length > 0)
            .join(';')
        }
        if (session !== uploadSession || !attachments.value.some(entry => entry.id === item.id)) continue
        item.progress = 100
        item.status = 'ready'
        outlineParams.value.fujian = documentContent.value
        outlineParams.value.pics = [...pics.value]
      } catch (err) {
        if (session !== uploadSession || !attachments.value.some(entry => entry.id === item.id)) continue
        item.status = 'error'
        ElMessage.error({ message: err instanceof Error ? err.message : '文件上传失败', offset: 60 })
      } finally {
        stopUploadProgress(item.id)
      }
    }
  } finally {
    if (session === uploadSession) isUploading.value = false
  }
}

const handleBeautifyPptFile = async (file) => {
  if (file.size > MAX_UPLOAD_SIZE) {
    showUploadSizeError(file.name)
    return
  }
  const ext = `.${checkFileType(file.name)}`
  if (ext !== '.pptx') {
    ElMessage.error({
      message: '仅支持上传 .pptx 文件',
      offset: 60,
    })
    return
  }

  reportEvent('app_clicks', {
    ck_module: '首页_PPT美化_上传PPT',
  })

  cleareFiles()
  localFileInfo.value = {
    name: file.name,
    status: 'uploading'
  }

  try {
    const pptJson = await importPPTXFile([file], { cover: true })
    if (!pptJson?.slides?.length) {
      localFileInfo.value.status = 'error'
      ElMessage.error({
        message: 'PPT解析失败，请重新上传',
        offset: 60,
      })
      return
    }

    const enhancePptParams = buildEnhancePptParams(pptJson)
    if (!enhancePptParams.success) {
      localFileInfo.value.status = 'error'
      ElMessage.error({
        message: enhancePptParams.error || 'PPT内容处理失败，请重新上传',
        offset: 60,
      })
      return
    }

    localFileInfo.value.status = 'success'
    outlineParams.value.inputText = file.name.replace(/\.(pptx)$/i, '')
    outlineParams.value.enhancePptJson = enhancePptParams
    outlineParams.value.applicationWorkflowParams = null
    slidesStore.setSlides([])
    router.push('/m/create')
  } catch (error) {
    localFileInfo.value.status = 'error'
    ElMessage.error({
      message: 'PPT解析失败，请重试',
      offset: 60,
    })
  } finally {
    if (fileInput.value) {
      fileInput.value.value = ''
    }
  }
}

const cleareFiles = () => {
  disposeAttachments()
  outlineParams.value.fujian = ''
  outlineParams.value.pics = []
  fileStore.clearFile()
  if (uploadRuntime) {
    uploadRuntime.removeFile()
  }
  localFileInfo.value = null
  if (fileInput.value) {
    fileInput.value.value = ''
  }
}

const checkFileType = (filename) => {
  const ext = filename.split('.').pop()?.toLowerCase() || ''
  return ext
}

const handleDraftStorageChange = (event) => {
  if (event.key !== OUTLINE_DRAFT_STORAGE_KEY || event.newValue !== null) return
  cleareFiles()
  appStore.clearOutlineFormDraft()
}

const handleAllTemplates = () => {
  reportEvent('app_clicks', { ck_module: 'PPT制作_首页_点击全部模版' })
  if (isMiniAppWebview()) {
    requestMiniAppSwitchTab('template')
    return
  }
  if (window.JsAndroid) {
    window.location.href = `ydppt://index?tab=template`
    return
  }
  if (window.prompt) {
    window.location.href = `ydppt://index?tab=template`
    return
  }
  router.push('/m/Template')
}

const handleMobileApplicationMore = () => {
  reportEvent('app_clicks', {
    ck_module: 'PPT制作_首页_热门专题_查看更多',
  })
  if (isMiniAppWebview()) {
    requestMiniAppOpenWebview({ path: '/m/applications', title: 'PPT专题' })
    return
  }
  if (window.JsAndroid) {
    window.location.href = `ydppt://index?tab=application`
    return
  }
  if (window.prompt) {
    window.location.href = `ydppt://index?tab=application`
    return
  }
  router.push('/m/applications')
}

const handleMobileApplicationClick = (app) => {
  reportEvent('app_clicks', {
    ck_module: `PPT制作_首页_热门专题_${app.title}`,
  })
  const target = router.resolve({
    path: '/m/application/create',
    query: { id: app.id, title: app.title },
  })
  if (isMiniAppWebview()) {
    requestMiniAppOpenWebview({ path: target.href, title: app.title || 'PPT专题' })
    return
  }
  if (isIOS) {
    router.push(target.href)
    return
  }
  const url = new URL(target.href, window.location.origin).href
  window.location.href = `ydppt://webview?url=${encodeURIComponent(url)}&title=`
}

const getMobileHomeApplications = async () => {
  mobileHotApplicationsLoading.value = true
  try {
    const res = await HomeApi.getBotHome({
      params: {
        pageNo: 1,
      },
    })
    if (isBotHomeSuccess(res)) {
      const list = normalizeApplicationList(getBotHomeListFromResponse(res)).slice(0, 4)
      mobileHotApplications.value = list
    }
  } catch (err) {
    console.error('移动端首页热门应用获取失败:', err)
    mobileHotApplications.value = []
  } finally {
    mobileHotApplicationsLoading.value = false
  }
}

const openBannerWebview = (url) => {
  suspendHomePopups()
  window.location.href = url
}

const goAndiroMember = (item) => {
  reportEvent('app_clicks', {
    ck_module: item.title,
  })

  setTimeout(() => {
    const linkUrl = item.linkUrl || ''

    // 小程序：对齐原生 ydppt://webview，打开全屏 web-view 页
    if (isMiniAppWebview()) {
      if (linkUrl.startsWith('web:')) {
        router.push(linkUrl.replace('web:', ''))
        return
      }
      if (linkUrl.startsWith('ydppt:')) {
        // 原生协议在小程序内不可用，忽略
        return
      }

      // 会员页跳转小程序 tab 会员页
      if (/\/m\/member/i.test(linkUrl)) {
        requestMiniAppSwitchTab('member')
        return
      }

      // 外链（含 activity:https://...）：先开业务域名中转页，再尝试跳转/复制
      const externalUrl = linkUrl.startsWith('activity:')
        ? linkUrl.replace('activity:', '')
        : linkUrl
      if (/^https?:\/\//i.test(externalUrl)) {
        const title = item.title || '活动详情'
        requestMiniAppOpenWebview({
          path: `/m/open-link?target=${encodeURIComponent(externalUrl)}&title=${encodeURIComponent(title)}`,
          title,
        })
        return
      }

      // 业务 H5 相对路径：交给小程序 pages/webview 拼域名 + token
      const path = linkUrl.startsWith('/') ? linkUrl : `/${linkUrl}`
      requestMiniAppOpenWebview({
        path,
        title: item.title || '详情',
      })
      return
    }

    if (linkUrl.startsWith('ydppt:')) {
      if (window.JsAndroid) {
        openBannerWebview(linkUrl)
      } else if (window.prompt) {
        const isLogin = window.prompt('ydppt://isLogin')
        const isLoggedIn = isLogin !== null && isLogin !== undefined && isLogin !== 'false'
        if (isLoggedIn) {
          openBannerWebview(linkUrl)
        } else {
          window.prompt('ydppt://login')
        }
      }
    } else if (linkUrl.startsWith('web:')) {
      const url = linkUrl.replace('web:', '')
      router.push(url)
    } else if (linkUrl.startsWith('activity:')) {
      const url = linkUrl.replace('activity:', '')
      openBannerWebview('ydppt://webview?url=' + url)
    } else if (linkUrl.startsWith('webview:')) {
      //给不使用title的链接使用
      const url = linkUrl.replace('webview:', '')
      openBannerWebview('ydppt://webview?url=' + location.origin  + url + '&title=')
    } else if(/^https?:\/\//.test(linkUrl)){
      console.log('linkUrl',linkUrl);
      
      if(window.JsAndroid || window.prompt){
        // const isMiniappHome = linkUrl.startsWith('https://testweb.gongwenbao-ai.com/miniapp/home')
        const webviewTitle = (item.title || '') 
        openBannerWebview('ydppt://webview?url=' + encodeURIComponent(linkUrl) + '&title=' + encodeURIComponent(webviewTitle))
      } else {
        window.location.href = linkUrl
      }
    } else if(linkUrl.startsWith('/')){
      if(window.JsAndroid || window.prompt){
        const separator = linkUrl.includes('?') ? '&' : '?'
        openBannerWebview('ydppt://webview?url=' + location.origin  + linkUrl + separator + 'fromType=home' + '&title=' + encodeURIComponent(item.title || ''));
      } else {
        push(linkUrl)
      }
    } else {
      // push(url);
      openBannerWebview('ydppt://webview?url=' + location.origin  + linkUrl+ '?fromType=home' + '&title=');
    }
  }, 150)
}

const handleTemplateScroll = () => {
  const container = templateScrollContainerRef.value
  if (!container || templatesLoading.value || templatesLoadingMore.value || !templatesHasMore.value) return

  const { scrollTop, scrollHeight, clientHeight } = container
  if (scrollHeight - scrollTop - clientHeight < TEMPLATE_SCROLL_THRESHOLD) {
    fetchTemplates()
  }
}

const handleTemplateClick = (template) => {
  // persistMobileCreateDraft()
  // if (!ensureNativeLogin()) return
  slidesStore.setYdTemplates(template)
  if (isMiniAppWebview()) {
    requestMiniAppOpenWebview({
      path: `/m/Template/detail?id=${template.id}&from=home`,
      title: '模板详情',
    })
    return
  }
  router.push({
    path: '/m/Template/detail',
    query: {
      id: template.id,
      from: 'home'
    }
  })
}

const shouldShowTemplateHomepage = (template) => Boolean(template?.homepage && !template?.homepageLoadFailed)

const handleTemplateHomepageError = (template) => {
  if (template) {
    template.homepageLoadFailed = true
  }
}

const fetchTemplates = async (reset = false) => {
  if (reset) {
    if (templatesLoading.value || templatesLoadingMore.value) return
    templatesLoading.value = true
    templatesPageNo.value = 1
  } else {
    if (templatesLoading.value || templatesLoadingMore.value || !templatesHasMore.value) return
    templatesLoadingMore.value = true
    templatesPageNo.value += 1
  }

  try {
    const params = {
      pageNo: templatesPageNo.value,
      pageSize: TEMPLATE_PAGE_SIZE
    }
    const res = await TemplateApi.getPPTPageList({ params })

    if (res.code === 'SUCCESS' && res.data) {
      const list = (res.data.list || []).map(normalizeTemplateItem)
      if (reset) {
        templates.value = list
      } else {
        templates.value = [...templates.value, ...list]
      }
      templatesTotal.value = res.data.total || 0
    } else if (reset) {
      templates.value = []
      templatesTotal.value = 0
    }
  } catch (error) {
    console.error('获取模板列表失败:', error)
    if (!reset) {
      templatesPageNo.value = Math.max(1, templatesPageNo.value - 1)
    } else {
      templates.value = []
      templatesTotal.value = 0
    }
  } finally {
    if (reset) {
      templatesLoading.value = false
    }
    templatesLoadingMore.value = false
  }
}


const handleCreate = () => {
  reportEvent('app_clicks', {
    ck_module: '首页_立即生成',
  })
  if (isUploading.value) {
    ElMessage.warning({ message: '文件正在上传中，请稍后', offset: 60 })
    return
  }
  if (!canSubmit.value) {
    ElMessage.error({
      message: '请输入要生成PPT的主题或上传参考文档',
      offset: 60,
    })
    return
  }

  // 上传中或失败时阻止提交
  if (localFileInfo.value && localFileInfo.value.status === 'uploading') {
    ElMessage.error({
      message: '文件正在上传中，请稍后',
      offset: 60,
    })
    return
  }
  if (localFileInfo.value && localFileInfo.value.status === 'error') {
    ElMessage.error({
      message: '文件上传失败，请重新上传',
      offset: 60,
    })
    return
  }

  if (!ensureNativeLogin()) return

  outlineParams.value.enhancePptJson = null
  outlineParams.value.applicationWorkflowParams = null

  if (isMiniAppWebview()) {
    // 新开独立 web-view 会丢 Pinia 内存态：localStorage + cookie + URL(base64) 三通道带草稿
    persistOutlineDraftIfPossible()
    const draft = {
      inputText: outlineParams.value.inputText || '',
      pageCount: outlineParams.value.pageCount || defaultOutlineOptions.pageCount,
      language: outlineParams.value.language || defaultOutlineOptions.language,
      audiences: outlineParams.value.audiences || defaultOutlineOptions.audiences,
      textVolume: outlineParams.value.textVolume || defaultOutlineOptions.textVolume,
      scene: outlineParams.value.scene || defaultOutlineOptions.scene,
      fujian: outlineParams.value.fujian || uploadedFile.value?.fujian || '',
      pics: [...(outlineParams.value.pics || [])],
      fileName: localFileInfo.value?.name || uploadedFile.value?.name || '',
    }
    saveOutlineDraftToStorage(draft)
    writeOutlineDraftToCookie(draft)

    let h5Draft = ''
    try {
      const encoded = encodeOutlineDraftForTransport(draft)
      // base64 通常比 raw JSON 更短且无特殊字符，优先塞进小程序 URL
      if (encoded.length <= 1200) h5Draft = encoded
    } catch {
      /* ignore */
    }

    requestMiniAppOpenWebview({
      path: '/m/create',
      title: '生成大纲',
      fullscreen: true,
      fromTab: 'home',
      h5Draft: h5Draft || undefined,
    })
    return
  }

  router.push('/m/create')
}

const getUser = async (data) => {
  const { getUserInfo } = await import('@/api/user.ts')
  getUserInfo(data).then(res => {
    if (res.code === 'SUCCESS') {
      userStore.setUserInfo(res.data)
    }
  })
}

// 监听 uploadedFile 变化，同步本地状态（例如从其他页面返回）
watch(uploadedFile, (newFile) => {
  if (newFile && newFile.name) {
    if (!localFileInfo.value || localFileInfo.value.name !== newFile.name) {
      localFileInfo.value = {
        name: newFile.name,
        status: 'success'
      }
    }
  } else if (!newFile) {
    localFileInfo.value = null
  }
}, { immediate: true, deep: true })


window.getHome = function(){
  getHomeBannerList()
  fetchUnreadCount()
}

onMounted(() => {
  syncTabBarHeightIfNeeded(tabBarHeight.value, (h) => appStore.setTabBarHeight(h))
  setupCustomGesture()
  fetchUnreadCount()
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      getUser()
    }, { timeout: 1500 })
  } else {
    setTimeout(() => {
      getUser()
    }, 500)
  }
  fetchTemplates(true)
  showAndiroTab(true)
  reportEvent('page_view', {
    page_name: '首页',
  });
  getMobileHomeApplications()
  init()
  window.addEventListener(NOTIFICATION_UNREAD_REFRESH_EVENT, fetchUnreadCount)
  window.addEventListener(LOGIN_SUCCESS_EVENT, handleLoginSuccess)
  window.addEventListener('storage', handleDraftStorageChange)
})

onActivated(setupCustomGesture)
onDeactivated(teardownCustomGesture)

onBeforeUnmount(() => {
  disposeAttachments()
  clearHotMarqueeTimer()
  teardownCustomGesture()
  window.removeEventListener(NOTIFICATION_UNREAD_REFRESH_EVENT, fetchUnreadCount)
  window.removeEventListener(LOGIN_SUCCESS_EVENT, handleLoginSuccess)
  window.removeEventListener('storage', handleDraftStorageChange)
})
</script>

<style lang="scss" scoped>
.mobile-attachment-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  padding: 4px;
  margin-bottom: 12px;
}

.mobile-attachment-card {
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 10px;
  width: 230px;
  padding: 12px 22px 12px 14px;
  border-radius: 16px;
  background: #f7f7f7;
  box-sizing: border-box;
}

.mobile-attachment-icon {
  width: 30px;
  height: 34px;
  object-fit: contain;
  flex-shrink: 0;
}

.mobile-attachment-info {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.mobile-attachment-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #333;
  font-size: 14px;
}

.mobile-attachment-status {
  margin-top: 4px;
  color: #999;
  font-size: 12px;

  &.is-error {
    color: #D92D20;
  }
}

.mobile-attachment-remove {
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #111;
  color: white;
  line-height: 1;
}

.mobile-attachment-remove-icon {
  width: 12px;
  height: 12px;
}

.mobile-attachment-progress {
  height: 3px;
  margin-top: 6px;
  border-radius: 3px;
  background: #e8e8e8;
  overflow: hidden;
}

.mobile-attachment-progress span {
  display: block;
  height: 100%;
  background: #326cff;
  transition: width .2s;
}

.mobile-text-input-area {
  position: relative;
}

.main-input-wrapper .mobile-text-input-area .shiny-placeholder {
  top: 0;
  left: 0;
  right: 0;
}

.home-mobile {
  background-size: 100% auto;
  background-image: url('@/assets/images/mobile/mobile_home_bg.png');
  background-repeat: no-repeat;
}

.yidian-home-content {
  // box-shadow: 0px 13px 19px 0px rgba(102, 145, 254, 0.14);
}

.miniapp-ai-disclaimer {
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
  line-height: 1.4;
  color: #9aa0a6;
  font-weight: 400;
}

.mobile-hot-apps {
  padding: 12px;
  border-radius: 16px;
  background: #FFFFFF;
}

.mobile-hot-apps-header {
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: space-between;
}

.mobile-hot-apps-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;

  img {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
    object-fit: contain;
  }

  h2 {
    margin: 0;
    color: #1D1F26;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    white-space: nowrap;
  }
}

.mobile-hot-apps-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(6, 10, 38, 0.6);
  cursor: pointer;
  font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;

  img {
    width: 12px;
    height: 12px;
    object-fit: contain;
    opacity: 0.72;
  }
}

.mobile-hot-apps-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.mobile-hot-app-card {
  position: relative;
  display: flex;
  height: 65px;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  padding: 13px 10px 13px 12px;
  border: 1px solid rgba(241, 243, 248, 1);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(246, 247, 249, 1) 0%, rgba(248, 249, 253, 1) 100%);
  cursor: pointer;
  text-align: left;
}

.mobile-hot-app-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px 0 0 0;
  object-fit: contain;
  pointer-events: none;
}

.mobile-hot-app-text {
  position: relative;
  z-index: 1;
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 6px;

  strong {
    overflow: hidden;
    color: rgba(54, 47, 47, 1);
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    overflow: hidden;
    color: rgba(54, 47, 47, 0.6);
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.mobile-hot-app-icon {
  position: relative;
  z-index: 1;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  margin-left: 6px;
  object-fit: contain;
}

/* 与应用中心一致，角标上缘外露卡片顶部 */
.mobile-hot-app-badge {
  position: absolute;
  top: -3px;
  right: 4px;
  z-index: 2;
  width: 27px;
  height: 16px;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 9px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
}

.mobile-hot-app-badge-new {
  background: linear-gradient(90deg, rgb(50, 108, 255) 0%, rgb(97, 142, 255) 100%);
}

.mobile-hot-app-badge-hot {
  background: linear-gradient(90deg, #FF3D00 0%, #FF7A00 100%);
}

.mobile-hot-app-card--skeleton {
  cursor: default;
}

.mobile-hot-app-skeleton-content {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.mobile-hot-app-skeleton-title {
  width: 58px;
  height: 16px;
}

.mobile-hot-app-skeleton-desc {
  width: 92px;
  height: 14px;
  margin-top: 8px;
}

.mobile-hot-app-skeleton-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border-radius: 10px;
}

.mobile-hot-apps-empty {
  grid-column: 1 / -1;
  padding: 18px 0;
  color: rgba(6, 10, 38, 0.38);
  font-size: 13px;
  text-align: center;
}

.yidian-mobile-btn {
  background: linear-gradient( 90deg, #5787FF 0%, #1858F7 100%);

  &.btn-disabled {
    // background: #cccccc;
    opacity: 0.4;
    cursor: not-allowed !important;
  }

  &.btn-enabled {
    &:active {
      transform: scale(0.98);
      transition: transform 0.1s ease;
    }
  }
}

.mobile-input-options-row {
  margin-bottom: 16px;
}

.mobile-input-options-scroll-wrap {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 36px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255,0.8) 100%);
    pointer-events: none;
    z-index: 1;
  }
}

.mobile-input-options-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.input-options-inner {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  min-width: 100%;
}

.option-select-trigger {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  min-height: 33px;
  padding: 0 12px;
  background: rgba(6,10,38,0.03);
  border: 1px solid rgba(6,10,38,0.03);
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;

  .option-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  .option-label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 500;
  }

  .option-label-name {
    color: rgba(6, 10, 38, 0.6);
  }

  .option-label-value {
    color: #060a26;
  }

  .option-arrow {
    font-size: 14px;
    color: #94A3B8;
  }
}

.option-edit-btn {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: #666772;
  cursor: pointer;
  background: transparent;
  // border: 1px solid #f0f4ff;
  border-radius: 12px;
}

.mobile-hot-topics {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-hot-topics-row {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.hot-topics-inner {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  animation: hot-topics-marquee linear infinite;
  will-change: transform;

  &.is-marquee-paused {
    animation-play-state: paused;
  }

  &.is-marquee-manual {
    animation: none;
    transform: none;
  }
}

@keyframes hot-topics-marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.hot-topic-item {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  max-width: 200px;
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
  line-height: 1;
  color: rgba(6,10,38,0.6);
  border: 1px solid rgba(6,10,38,0.06);
  white-space: nowrap;
  cursor: pointer;
  border-radius: 46px;
}

.mobile-input-mode-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
  max-width: 100%;
  margin: 2px auto 12px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(42, 94, 255, 0.08);
}

.mobile-input-mode-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 96px;
  height: 36px;
  padding: 0 10px;
  border: none;
  border-radius: 11px;
  background: transparent;
  color: #101828;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;

  &.is-active {
    background: rgba(50,108,255,0.06);
  }
}

.mobile-input-mode-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  object-fit: contain;
}

.main-input-wrapper {
  position: relative;
  margin-bottom: 14px;

  .gradient-border {
    position: relative;
    border-radius: 16px;
    padding: 1px;
    /* 这里的 2px 即为边框宽度 */
    /* 直接把渐变加在这里，去掉 ::before */
    background: linear-gradient(97deg, rgba(85, 139, 255, 1), rgba(152, 229, 255, 1));
    box-shadow: 0px 6px 9px 0px rgba(117,128,255,0.12);
  }

  .input-content {
    position: relative;
    background-color: white;
    /* 遮住中间的渐变，只漏出 padding 区域 */
    /* 关键点：内部圆角 = 外部圆角 - padding宽度 */
    /* 30px - 2px = 28px，这样看起来圆角才同心，不会粗细不均 */
    border-radius: 15px;
    padding: 12px;
    height: 100%;
    /* 确保填满高度 */
  }

  .main-input {
    width: 100%;
    min-height: 60px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
    resize: none;
    color: #333;

    &:focus {
      outline: none;
      background-color: white;
    }

    &::placeholder {
      color: #999;
    }
  }

  .shiny-placeholder {
    position: absolute;
    top: 12px;
    left: 12px;
    right: 12px;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
    text-align: left;
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: transparent;
    background-image: linear-gradient(
      90deg,
      rgba(129, 140, 155, 0.86) 0%,
      rgba(129, 140, 155, 0.86) 42%,
      rgba(6, 10, 38, 0.92) 50%,
      rgba(129, 140, 155, 0.86) 58%,
      rgba(129, 140, 155, 0.86) 100%
    );
    background-size: 150% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    animation: shiny-text-flow 3.3s linear infinite;
    z-index: 2;
  }

  .input-actions {
    display: flex;
    justify-content: space-between;
    align-items: end;
    // margin-top: 12px;
    gap: 12px;

    .input-char-count {
      margin-left: auto;
      flex-shrink: 0;
      font-size: 11px;
      line-height: 1;
      color: rgba(6, 10, 38, 0.35);
      pointer-events: none;
      white-space: nowrap;
    }

    /* 文件信息条样式 */
    .file-info-box {
      // flex: 1;
      // height: 72px;
      padding: 8px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid rgba(9, 24, 54, 0.07);

      .file-info-content {
        display: flex;
        align-items: center;
        width: 100%;


        .file-icon {
          flex-shrink: 0;
        }


        .file-status {
          .is-loading {
            animation: rotating 1.5s linear infinite;
          }
        }
      }
    }

    .upload-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 30px;
      padding: 6px 8px 6px 6px;
      border: 1px solid rgba(6,10,38,0.06);
      border-radius: 8px;
      background-color: white;
      color: #1D1F26;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s ease;
    }
  }

  .upload-content {
    background-color: white;
    border-radius: 15px;
    padding: 0;
  }

  .mobile-upload-panel {
    display: flex;
    width: 100%;
    min-height: 156px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 18px 16px;
    border: none;
    border-radius: 15px;
    background: #fff;
    cursor: pointer;
    text-align: center;
  }

  .mobile-upload-main-icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }

  .mobile-upload-file-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 4px;

    img {
      width: 36px;
      height: 42px;
      object-fit: contain;
      filter: drop-shadow(0 4px 6px rgba(15, 23, 42, 0.12));
    }
  }

  .mobile-upload-title {
    color: #111827;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
  }

  .mobile-upload-desc {
    color: rgba(6, 10, 38, 0.42);
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.option-drawer-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 16px 20px;
  box-sizing: border-box;
}

.option-drawer-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  overflow-x: auto;
  flex-shrink: 0;

  &::-webkit-scrollbar {
    display: none;
  }
}

.option-drawer-tab {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 56px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #060a26;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: 23px;
  white-space: nowrap;
  transition: all 0.2s ease;

  &.is-active {
    color: #1858f7;
    background: rgba(50, 108, 255, 0.04);
  }
}

.option-drawer-tab-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.option-drawer-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.option-grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  color: #060a26;
  text-align: center;
  cursor: pointer;
  background: rgba(6, 10, 38, 0.03);
  border: none;
  border-radius: 40px;
  transition: all 0.2s ease;

  &.is-selected {
    color: #1858f7;
    background: rgba(50, 108, 255, 0.06);
  }

  &--custom {
    grid-column: span 1;
    gap: 6px;
    justify-content: center;
  }
}

.option-grid-custom-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.option-drawer-footer {
  display: flex;
  flex-shrink: 0;
  gap: 12px;
  margin-top: 16px;
}

.option-drawer-btn {
  flex: 1;
  height: 44px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  border-radius: 22px;
  transition: opacity 0.2s ease;

  &:active {
    opacity: 0.85;
  }

  &--ghost {
    color: #060a26;
    background: #fff;
    border: 1px solid rgba(6, 10, 38, 0.12);
  }

  &--primary {
    color: #fff;
    background: linear-gradient(90deg, #5787ff 0%, #1858f7 100%);
  }
}

.custom-scene-overlay {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  background: rgba(0, 0, 0, 0.45);
}

.custom-scene-modal {
  width: 100%;
  max-width: 320px;
  padding: 20px 16px 16px;
  background: #fff;
  border-radius: 16px;
}

.custom-scene-title {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: #060a26;
  text-align: center;
}

.custom-scene-input-wrap {
  position: relative;
  margin-bottom: 20px;
}

.custom-scene-input {
  width: 100%;
  height: 44px;
  padding: 0 52px 0 14px;
  font-size: 14px;
  color: #060a26;
  background: #f5f6f8;
  border: none;
  border-radius: 12px;
  outline: none;

  &::placeholder {
    color: rgba(6, 10, 38, 0.35);
  }
}

.custom-scene-count {
  position: absolute;
  top: 50%;
  right: 12px;
  font-size: 12px;
  color: rgba(6, 10, 38, 0.35);
  transform: translateY(-50%);
}

.custom-scene-actions {
  display: flex;
  gap: 12px;
}

.custom-scene-btn {
  flex: 1;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  border-radius: 20px;

  &--ghost {
    color: #060a26;
    background: #fff;
    border: 1px solid rgba(6, 10, 38, 0.12);
  }

  &--primary {
    color: #fff;
    background: linear-gradient(90deg, #5787ff 0%, #1858f7 100%);
  }
}

:deep(.mobile-option-drawer .el-drawer) {
  border-radius: 20px 20px 0 0;
}

:deep(.mobile-option-drawer .el-drawer__body) {
  height: 100%;
  padding: 0;
}

.member-banner {
  :deep(.member-banner-image) {
    width: 100%;
    display: block;
    border-radius: 12px;
    overflow: hidden;
  }
}

.swiper-member {
  border-radius: 12px;
  overflow: hidden;

  :deep(.swiper-slide) {
    cursor: pointer;
  }
}

/* 隐藏滚动条 */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

@keyframes shiny-text-flow {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -20% 0;
  }
}
</style>
